import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@mui/material/Button'
import { COLORS } from 'src/utils/Themes/colors'

const ChangePassword = (props) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.headingContainer}>
          <span>Change Password</span>
          <hr />
        </div>
        <div className={classes.formContainer}>
          <div className={classes.comingSoonContainer}>
            <span data-test={'coming-soon'} className={classes.comingSoon}>
              Coming Soon
            </span>
          </div>
        </div>

        <div className={classes.actionsContainer}>
          <Button className={classes.cancelButton} onClick={props?.closeModal}>
            CANCEL
          </Button>
        </div>
      </div>
    </>
  )
}

export default ChangePassword

const useStyles = makeStyles({
  mainContainer: {
    margin: '10px',
    backgroundColor: '#fff',
    padding: '10px',
  },
  headingContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
  },
  formContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
  },
  actionsContainer: {
    height: '100% !important',
    width: '100% !important',
    fontWeight: 'bolder',
    marginTop: '20px',
    gap: '10px',
    display: 'flex',
  },
  changePasswordButton: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_LIGHTBLUE,
    color: COLORS.WHITE,
    height: '24px',
    padding: '17px 15px !important',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_LIGHTBLUE,
    },
  },
  cancelButton: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_YELLOW,
    color: COLORS.WHITE,
    height: '24px',
    padding: '17px 15px !important',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_YELLOW,
    },
  },
  customTextField: {
    '& input::placeholder': {
      fontSize: '12px',
    },
  },
  comingSoonContainer: {
    color: COLORS.LIGHT_GREY,
    textAlign: 'center',
    display: 'flex',
    height: '100px',
    width: '100%',
  },
  comingSoon: {
    width: '100% !important',
    justifyContent: 'center',
    display: 'flex',
  },
})
